var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70968 5.5C5.48931 5.5 4.5 6.48931 4.5 7.70968V16.2903C4.5 17.5107 5.48931 18.5 6.70968 18.5H18C19.2204 18.5 20.2097 17.5107 20.2097 16.2903V7.70968C20.2097 6.48931 19.2204 5.5 18 5.5H6.70968ZM3.5 7.70968C3.5 5.93702 4.93702 4.5 6.70968 4.5H18C19.7727 4.5 21.2097 5.93702 21.2097 7.70968V16.2903C21.2097 18.063 19.7727 19.5 18 19.5H6.70968C4.93702 19.5 3.5 18.063 3.5 16.2903V7.70968Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54578 8.17835C3.66106 7.92742 3.95793 7.81746 4.20886 7.93274L11.8095 11.4246L11.8095 11.4246C11.9806 11.5032 12.1667 11.5439 12.355 11.5439C12.5432 11.5439 12.7293 11.5032 12.9004 11.4246L12.9004 11.4246L20.5011 7.93274C20.752 7.81746 21.0489 7.92742 21.1641 8.17835C21.2794 8.42928 21.1695 8.72615 20.9185 8.84143L13.3179 12.3333C13.0159 12.4721 12.6874 12.5439 12.355 12.5439C12.0226 12.5439 11.6941 12.4721 11.392 12.3333C11.392 12.3333 11.392 12.3333 11.392 12.3333L3.79139 8.84143C3.54046 8.72615 3.43049 8.42928 3.54578 8.17835Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c8377bb57e06255687f6d9653f023e8b.svg";
export { ForwardRef as ReactComponent };